import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../data/gridColumnType";


const initState = {
  templateName: '',
  subject: '',
  body: '',
  isActive: '',
}

const EmailTemplateForm = {
  name: "Email Template From",
  initialState: initState,
  section: [
    {
      sectionId: 'EmailTemplate',
      title: "Email Template Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "templateName",
          label: "Email Template Name",
          Field_Name: "templatename",
          fieldType: FormFieldTypes.INPUT,
          dataField: "templateName",
          fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0",
          },
        },

        {
          id: "subject",
          label: "Subject",
          Field_Name: "subject",
          fieldType: FormFieldTypes.INPUT,
          dataField: "subject",
          fieldSetting: {
            placeholder: "Please Enter Subject",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            placeholder: "",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 double-label-sec checkbox-style",
          },
        },

        {
          id: "body",
          label: "Email Body",
          Field_Name: "email body",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "body",
          fieldSetting: {
            placeholder: "Please Enter Email Details",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-6 mb-2 email-body-height",
          },
        },

      ]
    }
  ]
};

// formFields: [
// {
//   id: "templateName",
//   label: "Name",
//   Field_Name: "TemplateName",
//   fieldType: FormFieldTypes.INPUT,
//   dataField: "templateName",
//   fieldSetting: {
//     placeholder: "Enter Name",
//     allowSpace: true,
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0",
//   },
// },

// {
//   id: "subject",
//   label: "Subject",
//   Field_Name: "Subject",
//   fieldType: FormFieldTypes.INPUT,
//   dataField: "subject",
//   fieldSetting: {
//     placeholder: "Enter Subject",
//     allowSpace: true,
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-4 col-md-6 mb-2 validation-left-0",
//   },
// },
// {
//   id: "isActive",
//   label: "Active",
//   Field_Name: "IsActive",
//   fieldType: FormFieldTypes.CHECKBOX,
//   dataField: "isActive",
//   fieldSetting: {
//     placeholder: "",
//     allowSpace: true,
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-4 col-md-6 checkbox-style",
//   },
// },

// {
//   id: "body",
//   label: "Email Body",
//   Field_Name: "Email Body",
//   fieldType: FormFieldTypes.CKEDITOR,
//   dataField: "body",
//   fieldSetting: {
//     placeholder: "",
//     allowSpace: true,
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-12 col-md-6 mb-2 email-body-height",
//   },
// },

// ],

export const EmailTemplateGridConfig = {
  columns: [
    {
      name: "Email Template Name",
      fieldName: "templateName",
    },
    {
      name: "Subject",
      fieldName: "subject",
    },
    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};

export default EmailTemplateForm;
